/* 年度报告 */
/* keepAlive:该页面是否缓存 */
export default [
    {
        path: 'annualReport/index',
        name: 'annualReport',
        meta: {
            title: ''
        },
        component: () => import('@/views/annualReport/index.vue')
    }
  ]